"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrganisationCell = exports.OrganisationCellDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var image_element_1 = require("../elements/image-element");
var location_label_1 = require("./location-label");
var coalesce_1 = require("../../utils/coalesce");
exports.OrganisationCellDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    color: ", ";\n    padding: ", " 0 ", " 2px;\n  "], ["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    color: ", ";\n    padding: ", " 0 ", " 2px;\n  "])), theme_1.theme.COLOR('text'), theme_1.theme.UNIT(2), theme_1.theme.UNIT(2))
});
var NameStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(1))
});
var LogoStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width: 35%;\n    height: auto;\n  "], ["\n    width: 35%;\n    height: auto;\n  "])))
});
var LocationLabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    color: ", ";\n    font-size: 0.85em;\n  "], ["\n    color: ", ";\n    font-size: 0.85em;\n  "])), theme_1.theme.COLOR('text-mid'))
});
var InfoStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    display: flex;\n    flex-grow: 1;\n    justify-content: center;\n    flex-direction: column;\n    padding-top: ", ";\n    padding-bottom: ", ";\n    ", "\n  "], ["\n    display: flex;\n    flex-grow: 1;\n    justify-content: center;\n    flex-direction: column;\n    padding-top: ", ";\n    padding-bottom: ", ";\n    ", "\n  "])), theme_1.theme.UNIT(2), theme_1.theme.UNIT(2), function (props) {
    return props.hasLogo && (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      padding-left: ", ";\n      margin-left: ", ";\n      ", ";\n    "], ["\n      padding-left: ", ";\n      margin-left: ", ";\n      ", ";\n    "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(4), theme_1.theme.DOT_BG('v', 'line-mid', 2, 4));
  })
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Name: styled_components_1.default.span(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), NameStyles),
  Logo: (0, styled_components_1.default)(image_element_1.ImageElement)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), LogoStyles),
  LocationLabel: (0, styled_components_1.default)(location_label_1.LocationLabel)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), LocationLabelStyles),
  Info: styled_components_1.default.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), InfoStyles)
};
var OrganisationCell = function (props) {
  var className = props.className,
    entity = props.entity;
  var name = entity.name,
    location = entity.location;
  var logo = (0, coalesce_1.coalesce)(entity, ['logo', 'openGraph.image']);
  return react_1.default.createElement(My.Container, {
    className: className
  }, logo && react_1.default.createElement(My.Logo, {
    entity: logo
  }), react_1.default.createElement(My.Info, {
    hasLogo: !!logo
  }, react_1.default.createElement(My.Name, null, name), location && react_1.default.createElement(My.LocationLabel, {
    entity: location
  })));
};
exports.OrganisationCell = OrganisationCell;
exports.OrganisationCell.defaultProps = exports.OrganisationCellDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;